export default __webpack_public_path__ + "static/media/technology3.8cf7d40c.f6ba77e5.jpg";